import Dropdown from './dropdown.vue';

export default Dropdown;


// WEBPACK FOOTER //
// ./src/components/inputs/dropdown/index.js